import styled from '@emotion/styled';

export const StyledTitle = styled.div`
  display: flex;
  flex-direction: column;

  span {
    margin-top: -2rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.palette?.text?.secondary};
  }
`;

export const BoxHeading = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette?.brand.background.base};
`;

export const ProductDetailsContentHeaderButtons = styled.section`
  display: flex;
  margin-bottom: 1rem;

  button {
    width: auto;
    margin-right: 16px;
  }
`;
